import { ButtonSkeleton } from "@components/button/button.skeleton";

export const LearnStatesExportButtonSkeleton = () => {
	return <ButtonSkeleton />;
};
